import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-form-debug',
  templateUrl: './form-debug.component.html',
  styleUrls: ['./form-debug.component.scss'],
})
export class FormDebugComponent {
  @Input() formGroup!: FormGroup;

  isDebug = environment.debug;
  isOpen = true;

  mode: 'errors' | 'value' = 'value';
  selectedControl: string | null = null;

  protected readonly modes = ['errors', 'value'] as const;

  get controls(): readonly [null, ...string[]] {
    return [null, ...Object.keys(this.formGroup?.controls)] as const;
  }

  changeMode(mode: 'errors' | 'value') {
    this.mode = mode;
  }

  changeControl(control: string | null) {
    this.selectedControl = control;
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
}
